import React, {FunctionComponent} from "react"
import {Link} from "gatsby";
import {Divider} from "../../divider";

const styles = require('./blogTitleLink.component.scss');



interface TitleProps {
    sectionIcon?: string,
    mainTitle: string,
    sideTitle?: string,
    sideTitleLink?: string,
    divider: boolean
}


export const BlogTitleLink: FunctionComponent<TitleProps> = ({sectionIcon, mainTitle, divider, sideTitle, sideTitleLink}) => {
    return (
        <>
            <div className={styles.container}>
                {sideTitleLink ?
                    <div className={styles.titleLink}>
                            <Link to={`/${sideTitleLink}`}>
                        {sectionIcon &&
                        <div className={styles.sectionIcon}>
                            <img src={sectionIcon} alt=""/>
                        </div>
                        }
                            <div className={styles.mainTitleCont}>
                                <h2 className={styles.mainTitle}>{mainTitle}</h2>
                            </div>
                            <div className={styles.sideTitle}>
                                {sideTitle &&
                                <h4 className={styles.sectionLink}>
                                    <div className={styles.linkText}>
                                        {sideTitle}
                                        <i className="fa fa-arrow-right"/>
                                    </div>
                                </h4>
                                }
                            </div>
                        </Link>
                    </div>
                    :
                    <div className={styles.titleLink}>
                        {sectionIcon &&
                        <div className={styles.sectionIcon}>
                            <img src={sectionIcon} alt=""/>
                        </div>
                        }
                        <div className={styles.mainTitleCont}>
                            <h2 className={styles.mainTitle}>{mainTitle}</h2>
                        </div>
                    </div>
                }
            </div>
            <Divider direction={"horizontal"}/>
        </>
    )
}